/* eslint-disable max-lines -- one endpoint table for the routes API domain; declarations only */
import type {
  BookingForRoutePlannerListApiData,
  BookingForRoutePlannerListApiResponses,
  BookingItemForRouteItemListApiData,
  BookingItemForRouteItemListApiResponses,
  BookingItemForServiceWorkerGetApiData,
  BookingItemForServiceWorkerGetApiResponses,
  BookingItemMarkAsCompleteApiData,
  BookingItemMarkAsCompleteApiResponses,
  BookingItemsForRoutePlannerListApiData,
  BookingItemsForRoutePlannerListApiResponses,
  BookingItemWorkerDetailsGetApiData,
  BookingItemWorkerDetailsGetApiResponses,
  BookingMarkAsCompleteApiData,
  BookingMarkAsCompleteApiResponses,
  BookingStatusCountApiData,
  BookingStatusCountApiResponses,
  CapacityContributionForRoutePlannerApiData,
  CapacityContributionForRoutePlannerApiResponses,
  CapacityContributionListForNewRouteApiData,
  CapacityContributionListForNewRouteApiResponses,
  CapacityContributionListUnusedInRouteSolutionApiData,
  CapacityContributionListUnusedInRouteSolutionApiResponses,
  RouteConfirmApiData,
  RouteConfirmApiResponses,
  RouteCreateApiData,
  RouteCreateApiResponses,
  RouteDeleteApiData,
  RouteDeleteApiResponses,
  RouteEditApiData,
  RouteEditApiResponses,
  RouteEditPreviewApiData,
  RouteEditPreviewApiResponses,
  RouteEstimatedPaymentGetApiData,
  RouteEstimatedPaymentGetApiResponses,
  RouteForSolutionGetApiData,
  RouteForSolutionGetApiResponses,
  RouteGetApiData,
  RouteGetApiResponses,
  RouteGetDelayApiData,
  RouteGetDelayApiResponses,
  RouteInformationForServiceWorkerApiData,
  RouteInformationForServiceWorkerApiResponses,
  RouteItemCargoExpectationListApiData,
  RouteItemCargoExpectationListApiResponses,
  RouteItemCargoExpectationNotBroughtBulkApiData,
  RouteItemCargoExpectationNotBroughtBulkApiResponses,
  RouteItemCargoExpectationOverrideBulkApiData,
  RouteItemCargoExpectationOverrideBulkApiResponses,
  RouteItemCargoExpectationRevertBulkApiData,
  RouteItemCargoExpectationRevertBulkApiResponses,
  RouteItemCargoExpectationTireSeasonBulkApiData,
  RouteItemCargoExpectationTireSeasonBulkApiResponses,
  RouteItemCustomerOverviewApiData,
  RouteItemCustomerOverviewApiResponses,
  RouteItemForBookingApiData,
  RouteItemForBookingApiResponses,
  RouteItemForBreakApiData,
  RouteItemForBreakApiResponses,
  RouteItemForDepotApiData,
  RouteItemForDepotApiResponses,
  RouteItemForReloadApiData,
  RouteItemForReloadApiResponses,
  RouteItemForTransferApiData,
  RouteItemForTransferApiResponses,
  RouteItemMarkAsStartedApiData,
  RouteItemMarkAsStartedApiResponses,
  RouteItemReloadCargoExpectationScanBulkApiData,
  RouteItemReloadCargoExpectationScanBulkApiResponses,
  RouteItemReloadCompleteApiData,
  RouteItemReloadCompleteApiResponses,
  RouteItemReloadStartApiData,
  RouteItemReloadStartApiResponses,
  RouteItemSendDelaySmsApiData,
  RouteItemSendDelaySmsApiResponses,
  RouteItemSendNextArrivalSmsApiData,
  RouteItemSendNextArrivalSmsApiResponses,
  RouteItemsForServiceWorkerApiData,
  RouteItemsForServiceWorkerApiResponses,
  RouteItemTransferCargoExpectationAddToTransferApiData,
  RouteItemTransferCargoExpectationAddToTransferApiResponses,
  RouteItemTransferCargoExpectationLookupApiData,
  RouteItemTransferCargoExpectationLookupApiResponses,
  RouteItemTransferCargoExpectationNotBroughtBulkApiData,
  RouteItemTransferCargoExpectationNotBroughtBulkApiResponses,
  RouteItemTransferCargoExpectationOverrideBulkApiData,
  RouteItemTransferCargoExpectationOverrideBulkApiResponses,
  RouteItemTransferCargoExpectationRevertBulkApiData,
  RouteItemTransferCargoExpectationRevertBulkApiResponses,
  RouteItemTransferCargoExpectationScanBulkApiData,
  RouteItemTransferCargoExpectationScanBulkApiResponses,
  RouteItemTransferCargoExpectationTireSeasonBulkApiData,
  RouteItemTransferCargoExpectationTireSeasonBulkApiResponses,
  RouteItemTransferCompleteApiData,
  RouteItemTransferCompleteApiResponses,
  RouteItemTransferStartApiData,
  RouteItemTransferStartApiResponses,
  RouteNavigationApiData,
  RouteNavigationApiResponses,
  RouteOverviewByServiceDepartmentsApiData,
  RouteOverviewByServiceDepartmentsApiResponses,
  RoutePlannerStartApiData,
  RoutePlannerStartApiResponses,
  RoutePlanningPreviewApiData,
  RoutePlanningPreviewApiResponses,
  RouteProblemChangesGetApiData,
  RouteProblemChangesGetApiResponses,
  RouteProblemGetApiData,
  RouteProblemGetApiResponses,
  RouteProblemLifecycleEventsListApiData,
  RouteProblemLifecycleEventsListApiResponses,
  RouteProblemListApiData,
  RouteProblemListApiResponses,
  RouteProblemRunStatusApiData,
  RouteProblemRunStatusApiResponses,
  RouteProblemValidateApiData,
  RouteProblemValidateApiResponses,
  RouteSettlementGetApiData,
  RouteSettlementGetApiResponses,
  RouteSettlementGetForServiceWorkerApiData,
  RouteSettlementGetForServiceWorkerApiResponses,
  RouteSettlementPatchApiData,
  RouteSettlementPatchApiResponses,
  RouteSettlementSummaryForServiceWorkerApiData,
  RouteSettlementSummaryForServiceWorkerApiResponses,
  RoutesForLabelPrintingApiData,
  RoutesForLabelPrintingApiResponses,
  RoutesForMapListApiData,
  RoutesForMapListApiResponses,
  RoutesForServiceWorkerApiData,
  RoutesForServiceWorkerApiResponses,
  RoutesForServiceWorkerListApiData,
  RoutesForServiceWorkerListApiResponses,
  RoutesListApiData,
  RoutesListApiResponses,
  RouteSolutionAutoSelectConfigGetApiData,
  RouteSolutionAutoSelectConfigGetApiResponses,
  RouteSolutionAutoSelectConfigPatchApiData,
  RouteSolutionAutoSelectConfigPatchApiResponses,
  RouteSolutionGetApiData,
  RouteSolutionGetApiResponses,
  RouteSolutionSelectionRequestApiData,
  RouteSolutionSelectionRequestApiResponses,
  RouteSolutionsListApiData,
  RouteSolutionsListApiResponses,
  RoutesOverviewPrDayApiData,
  RoutesOverviewPrDayApiResponses,
  RoutesStatsApiData,
  RoutesStatsApiResponses,
  RouteStartApiData,
  RouteStartApiResponses,
  RoutesToDragAndDropApiData,
  RoutesToDragAndDropApiResponses,
  TransferRouteAddItemsApiData,
  TransferRouteAddItemsApiResponses,
  TransferRouteAddItemsPreviewApiData,
  TransferRouteAddItemsPreviewApiResponses,
  TransferRouteRoundSummaryApiData,
  TransferRouteRoundSummaryApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getRouteUrls = {
  getPaginatedRoutes: dataEndpoint<RoutesListApiData, RoutesListApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/', queryParams)
  }),
  getPaginatedRoutesForServiceWorker: dataEndpoint<
    RoutesForServiceWorkerListApiData,
    RoutesForServiceWorkerListApiResponses
  >({
    getUrl: ({ serviceWorkerId, ...rest }) => apiUrl(`service-workers/${serviceWorkerId}/routes/`, rest)
  }),
  getRoute: dataEndpoint<RouteGetApiData, RouteGetApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/`)
  }),
  getRouteForSolution: dataEndpoint<RouteForSolutionGetApiData, RouteForSolutionGetApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/for-solution/`)
  }),
  getRoutesOverview: dataEndpoint<
    RouteOverviewByServiceDepartmentsApiData,
    RouteOverviewByServiceDepartmentsApiResponses
  >({
    getUrl: (queryParams) => apiUrl('routes/by-service-department/', queryParams)
  }),
  getRoutePlanningPreview: dataEndpoint<RoutePlanningPreviewApiData, RoutePlanningPreviewApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/planning-preview/', queryParams)
  }),
  getRouteSolution: dataEndpoint<RouteSolutionGetApiData, RouteSolutionGetApiResponses>({
    getUrl: ({ routeSolutionId }) => apiUrl(`route-solutions/${routeSolutionId}/`)
  }),
  getRouteSolutionAutoSelectConfig: dataEndpoint<
    RouteSolutionAutoSelectConfigGetApiData,
    RouteSolutionAutoSelectConfigGetApiResponses
  >({
    getUrl: ({ routeSolutionAutoSelectConfigId }) =>
      apiUrl(`route-solution-auto-select-configs/${routeSolutionAutoSelectConfigId}/`)
  }),
  getCalendarBookings: dataEndpoint<BookingStatusCountApiData, BookingStatusCountApiResponses>({
    getUrl: (queryParams) => apiUrl('bookings/status-counts/', queryParams),
    skipConvertingToCamelCase: true
  }),
  getRoutesForCalendar: dataEndpoint<RoutesOverviewPrDayApiData, RoutesOverviewPrDayApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/overview/', queryParams)
  }),
  getCapacityContributionsForNewRoute: dataEndpoint<
    CapacityContributionListForNewRouteApiData,
    CapacityContributionListForNewRouteApiResponses
  >({
    getUrl: (queryParams) => apiUrl('capacity-contributions/for-new-route/', queryParams)
  }),
  postRoute: responseEndpoint<RouteCreateApiData, RouteCreateApiResponses>({
    getUrl: () => apiUrl('routes/'),
    getBody: (data) => data
  }),
  postRouteEditPreview: responseEndpoint<RouteEditPreviewApiData, RouteEditPreviewApiResponses>({
    getUrl: () => apiUrl('routes/edit/preview/'),
    getBody: (data) => data
  }),
  postRouteEdit: responseEndpoint<RouteEditApiData, RouteEditApiResponses>({
    getUrl: () => apiUrl('routes/edit/'),
    getBody: (data) => data
  }),
  getPaginatedRouteProblems: dataEndpoint<RouteProblemListApiData, RouteProblemListApiResponses>({
    getUrl: (queryParams) => apiUrl('route-problems/', queryParams)
  }),
  getPaginatedRouteSolutions: dataEndpoint<RouteSolutionsListApiData, RouteSolutionsListApiResponses>({
    getUrl: (queryParams) => apiUrl('route-solutions/', queryParams)
  }),
  getRouteProblem: dataEndpoint<RouteProblemGetApiData, RouteProblemGetApiResponses>({
    getUrl: ({ routeProblemId }) => apiUrl(`route-problems/${routeProblemId}/`)
  }),
  getRouteProblemChanges: dataEndpoint<RouteProblemChangesGetApiData, RouteProblemChangesGetApiResponses>({
    getUrl: ({ routeProblemId }) => apiUrl(`route-problems/${routeProblemId}/changes/`)
  }),
  getCapacityContributionsForRoutePlanner: dataEndpoint<
    CapacityContributionForRoutePlannerApiData,
    CapacityContributionForRoutePlannerApiResponses
  >({
    getUrl: (queryParams) => apiUrl('capacity-contributions/for-route-planner/', queryParams)
  }),
  getPaginatedRoutePlannerBookings: dataEndpoint<
    BookingForRoutePlannerListApiData,
    BookingForRoutePlannerListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/for-route-planner/', queryParams)
  }),
  getRoutePlannerBookingItems: dataEndpoint<
    BookingItemsForRoutePlannerListApiData,
    BookingItemsForRoutePlannerListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('booking-items/for-route-planner/', queryParams)
  }),
  getRouteProblemValidation: dataEndpoint<RouteProblemValidateApiData, RouteProblemValidateApiResponses>({
    getUrl: (queryParams) => apiUrl('route-problems/validate/', queryParams)
  }),
  getRouteProblemRunStatus: dataEndpoint<RouteProblemRunStatusApiData, RouteProblemRunStatusApiResponses>({
    getUrl: ({ routeProblemId }) => apiUrl(`route-problems/${routeProblemId}/run-status/`),
    sideEffectGet: true
  }),
  getRouteProblemLifecycleEvents: dataEndpoint<
    RouteProblemLifecycleEventsListApiData,
    RouteProblemLifecycleEventsListApiResponses
  >({
    getUrl: ({ routeProblemId }) => apiUrl(`route-problems/${routeProblemId}/lifecycle-events/`)
  }),
  postStartRoutePlanner: responseEndpoint<RoutePlannerStartApiData, RoutePlannerStartApiResponses>({
    getUrl: () => apiUrl('route-problems/start-route-planner/'),
    getBody: (data) => data
  }),
  postRouteSolutionSelectionRequest: responseEndpoint<
    RouteSolutionSelectionRequestApiData,
    RouteSolutionSelectionRequestApiResponses
  >({
    getUrl: ({ routeSolutionId }) => apiUrl(`route-solutions/${routeSolutionId}/selection-request/`)
  }),
  getUnusedCapacityContributionsInRouteSolution: dataEndpoint<
    CapacityContributionListUnusedInRouteSolutionApiData,
    CapacityContributionListUnusedInRouteSolutionApiResponses
  >({
    getUrl: ({ routeSolutionId, ...queryParams }) =>
      apiUrl(`route-solutions/${routeSolutionId}/unused-capacity-contributions/`, queryParams)
  }),
  deleteRoute: dataEndpoint<RouteDeleteApiData, RouteDeleteApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/`),
    getBody: (data) => data
  }),
  getRouteSettlement: dataEndpoint<RouteSettlementGetApiData, RouteSettlementGetApiResponses>({
    getUrl: ({ routeSettlementId }) => apiUrl(`route-settlements/${routeSettlementId}/`)
  }),
  patchRouteSettlement: responseEndpoint<RouteSettlementPatchApiData, RouteSettlementPatchApiResponses>({
    getUrl: ({ routeSettlementId }) => apiUrl(`route-settlements/${routeSettlementId}/`),
    getBody: (data) => data
  }),
  patchRouteSolutionAutoSelectConfig: responseEndpoint<
    RouteSolutionAutoSelectConfigPatchApiData,
    RouteSolutionAutoSelectConfigPatchApiResponses
  >({
    getUrl: ({ routeSolutionAutoSelectConfigId }) =>
      apiUrl(`route-solution-auto-select-configs/${routeSolutionAutoSelectConfigId}/`),
    getBody: (data) => data
  }),
  getRoutesDragNDrop: dataEndpoint<RoutesToDragAndDropApiData, RoutesToDragAndDropApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/to-drag-and-drop/', queryParams)
  }),
  getRouteLabels: dataEndpoint<RoutesForLabelPrintingApiData, RoutesForLabelPrintingApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/for-label-printing/', queryParams)
  }),
  postDelayedMessage: responseEndpoint<RouteItemSendDelaySmsApiData, RouteItemSendDelaySmsApiResponses>({
    getUrl: ({ pk }) => apiUrl(`route-items/${pk}/send-delay-sms/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  patchMarkRouteItemComplete: responseEndpoint<BookingMarkAsCompleteApiData, BookingMarkAsCompleteApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/mark-as-complete/`),
    getBody: ({ commentsWorker, notifyCustomer }) => ({ commentsWorker, notifyCustomer })
  }),
  postMarkRouteItemStarted: responseEndpoint<RouteItemMarkAsStartedApiData, RouteItemMarkAsStartedApiResponses>({
    getUrl: ({ pk }) => apiUrl(`route-items/${pk}/mark-as-started/`)
  }),
  getPaginatedRouteSettlementsForWorker: dataEndpoint<
    RouteSettlementGetForServiceWorkerApiData,
    RouteSettlementGetForServiceWorkerApiResponses
  >({
    getUrl: ({ userId, ...queryParams }) => apiUrl(`route-settlements/for-worker/${userId}/`, queryParams)
  }),
  getRouteSettlementSummaryForWorker: dataEndpoint<
    RouteSettlementSummaryForServiceWorkerApiData,
    RouteSettlementSummaryForServiceWorkerApiResponses
  >({
    getUrl: ({ userId, ...queryParams }) => apiUrl(`route-settlements/for-worker/${userId}/summary/`, queryParams)
  }),
  postStartRouteForServiceWorker: responseEndpoint<RouteStartApiData, RouteStartApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/start-route-for-service-worker/`),
    getBody: (data) => data
  }),
  postConfirmRouteForServiceWorker: responseEndpoint<RouteConfirmApiData, RouteConfirmApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/confirm-route-for-service-worker/`),
    getBody: (data) => data
  }),
  getRoutesForServiceWorker: dataEndpoint<RoutesForServiceWorkerApiData, RoutesForServiceWorkerApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/for-service-worker/', queryParams)
  }),
  getRouteItemsForServiceWorker: dataEndpoint<
    RouteItemsForServiceWorkerApiData,
    RouteItemsForServiceWorkerApiResponses
  >({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/route-items-for-service-worker/`)
  }),
  getEstimatedRoutePayment: dataEndpoint<RouteEstimatedPaymentGetApiData, RouteEstimatedPaymentGetApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/estimated-payment/`)
  }),
  getDelayForRoute: dataEndpoint<RouteGetDelayApiData, RouteGetDelayApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/delay/`)
  }),
  getRouteNavigation: dataEndpoint<RouteNavigationApiData, RouteNavigationApiResponses>({
    getUrl: ({ routeId, ...queryParams }) => apiUrl(`routes/${routeId}/navigation/`, queryParams)
  }),
  getBookingItemsForRoute: dataEndpoint<BookingItemForRouteItemListApiData, BookingItemForRouteItemListApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/booking-items-v2/`)
  }),
  getWorkerBookingItem: dataEndpoint<BookingItemWorkerDetailsGetApiData, BookingItemWorkerDetailsGetApiResponses>({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/worker-details/`)
  }),
  getBookingItemForRoute: dataEndpoint<
    BookingItemForServiceWorkerGetApiData,
    BookingItemForServiceWorkerGetApiResponses
  >({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/for-service-worker/`)
  }),
  getRouteItemCustomerOverview: dataEndpoint<RouteItemCustomerOverviewApiData, RouteItemCustomerOverviewApiResponses>({
    getUrl: ({ pk }) => apiUrl(`route-items/${pk}/customer-overview/`)
  }),
  getRouteItemForBooking: dataEndpoint<RouteItemForBookingApiData, RouteItemForBookingApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/for-booking/`)
  }),
  getRouteItemForBreak: dataEndpoint<RouteItemForBreakApiData, RouteItemForBreakApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/for-break/`)
  }),
  getRouteItemForDepot: dataEndpoint<RouteItemForDepotApiData, RouteItemForDepotApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/for-depot/`)
  }),
  getRouteItemForReload: dataEndpoint<RouteItemForReloadApiData, RouteItemForReloadApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/for-reload/`)
  }),
  getRouteItemCargoExpectations: dataEndpoint<
    RouteItemCargoExpectationListApiData,
    RouteItemCargoExpectationListApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/`)
  }),
  postScanRouteItemCargoExpectationsBulk: responseEndpoint<
    RouteItemReloadCargoExpectationScanBulkApiData,
    RouteItemReloadCargoExpectationScanBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/scan/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postOverrideRouteItemCargoExpectationsBulk: responseEndpoint<
    RouteItemCargoExpectationOverrideBulkApiData,
    RouteItemCargoExpectationOverrideBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/override-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postNotBroughtRouteItemCargoExpectationsBulk: responseEndpoint<
    RouteItemCargoExpectationNotBroughtBulkApiData,
    RouteItemCargoExpectationNotBroughtBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/not-brought-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postTireSeasonRouteItemCargoExpectationsBulk: responseEndpoint<
    RouteItemCargoExpectationTireSeasonBulkApiData,
    RouteItemCargoExpectationTireSeasonBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/tire-season-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postRevertRouteItemCargoExpectationsBulk: responseEndpoint<
    RouteItemCargoExpectationRevertBulkApiData,
    RouteItemCargoExpectationRevertBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/cargo-expectations/revert-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postRouteItemReloadStart: responseEndpoint<RouteItemReloadStartApiData, RouteItemReloadStartApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/reload/start/`)
  }),
  postRouteItemReloadComplete: responseEndpoint<RouteItemReloadCompleteApiData, RouteItemReloadCompleteApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/reload/complete/`)
  }),
  getRouteItemForTransfer: dataEndpoint<RouteItemForTransferApiData, RouteItemForTransferApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/for-transfer/`)
  }),
  postRouteItemTransferStart: responseEndpoint<RouteItemTransferStartApiData, RouteItemTransferStartApiResponses>({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/start/`)
  }),
  postRouteItemTransferComplete: responseEndpoint<
    RouteItemTransferCompleteApiData,
    RouteItemTransferCompleteApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/complete/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postScanRouteItemTransferCargoExpectationsBulk: responseEndpoint<
    RouteItemTransferCargoExpectationScanBulkApiData,
    RouteItemTransferCargoExpectationScanBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/scan/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postOverrideRouteItemTransferCargoExpectationsBulk: responseEndpoint<
    RouteItemTransferCargoExpectationOverrideBulkApiData,
    RouteItemTransferCargoExpectationOverrideBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/override-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postNotBroughtRouteItemTransferCargoExpectationsBulk: responseEndpoint<
    RouteItemTransferCargoExpectationNotBroughtBulkApiData,
    RouteItemTransferCargoExpectationNotBroughtBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/not-brought-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postRevertRouteItemTransferCargoExpectationsBulk: responseEndpoint<
    RouteItemTransferCargoExpectationRevertBulkApiData,
    RouteItemTransferCargoExpectationRevertBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/revert-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  postTireSeasonRouteItemTransferCargoExpectationsBulk: responseEndpoint<
    RouteItemTransferCargoExpectationTireSeasonBulkApiData,
    RouteItemTransferCargoExpectationTireSeasonBulkApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/tire-season-bulk/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  getRouteItemTransferCargoExpectationLookup: dataEndpoint<
    RouteItemTransferCargoExpectationLookupApiData,
    RouteItemTransferCargoExpectationLookupApiResponses
  >({
    getUrl: ({ routeItemId, ...rest }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/lookup/`, rest)
  }),
  postRouteItemTransferCargoExpectationAddToTransfer: responseEndpoint<
    RouteItemTransferCargoExpectationAddToTransferApiData,
    RouteItemTransferCargoExpectationAddToTransferApiResponses
  >({
    getUrl: ({ routeItemId }) => apiUrl(`route-items/${routeItemId}/transfer/cargo-expectations/add-to-transfer/`),
    getBody: ({ routeItemId: _, ...body }) => body
  }),
  getTransferRouteRoundSummary: dataEndpoint<TransferRouteRoundSummaryApiData, TransferRouteRoundSummaryApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/transfer-round-summary/`)
  }),
  patchTransferRouteAddItems: responseEndpoint<TransferRouteAddItemsApiData, TransferRouteAddItemsApiResponses>({
    getUrl: ({ routeId }) => apiUrl(`routes/${routeId}/transfer-add-items/`),
    getBody: ({ routeId: _, ...body }) => body
  }),
  getTransferRouteAddItemsPreview: dataEndpoint<
    TransferRouteAddItemsPreviewApiData,
    TransferRouteAddItemsPreviewApiResponses
  >({
    getUrl: ({ routeId, ...rest }) => apiUrl(`routes/${routeId}/transfer-add-items-preview/`, rest)
  }),
  patchMarkBookingItemsAsComplete: responseEndpoint<
    BookingItemMarkAsCompleteApiData,
    BookingItemMarkAsCompleteApiResponses
  >({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/mark-as-complete/`),
    getBody: (data) => data
  }),
  patchMarkBookingAsComplete: responseEndpoint<BookingMarkAsCompleteApiData, BookingMarkAsCompleteApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/mark-as-complete/`),
    getBody: (data) => data
  }),
  postNextCustomerArrivalSMS: responseEndpoint<
    RouteItemSendNextArrivalSmsApiData,
    RouteItemSendNextArrivalSmsApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`route-items/${pk}/send-next-arrival-sms/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  getMapSegmentsForRoute: dataEndpoint<RoutesForMapListApiData, RoutesForMapListApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/for-map/', queryParams)
  }),
  getRouteInformationForServiceWorker: dataEndpoint<
    RouteInformationForServiceWorkerApiData,
    RouteInformationForServiceWorkerApiResponses
  >({
    getUrl: (queryParams) => apiUrl('routes/route-information/', queryParams)
  }),
  getRouteStats: dataEndpoint<RoutesStatsApiData, RoutesStatsApiResponses>({
    getUrl: (queryParams) => apiUrl('routes/stats/', queryParams)
  })
};
